import React from "react";

/* A single base wrapper so every icon shares consistent stroke behaviour and
   accepts `className` + an overridable `stroke` width (the page passes both). */
function Svg({ children, className, stroke = 1.8, ...rest }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...rest}
    >
      {children}
    </svg>
  );
}

export const IconArrow = (p) => (
  <Svg {...p}>
    <path d="M5 12h13" />
    <path d="m12.5 6 6 6-6 6" />
  </Svg>
);

export const IconBook = (p) => (
  <Svg {...p}>
    <path d="M4 5.5A2.5 2.5 0 0 1 6.5 3H19v15H6.5A2.5 2.5 0 0 0 4 20.5z" />
    <path d="M4 20.5A2.5 2.5 0 0 1 6.5 18H19" />
    <path d="M12 3v15" />
  </Svg>
);

export const IconGlobe = (p) => (
  <Svg {...p}>
    <circle cx="12" cy="12" r="9" />
    <path d="M3 12h18" />
    <path d="M12 3c2.6 2.6 2.6 15.4 0 18M12 3c-2.6 2.6-2.6 15.4 0 18" />
  </Svg>
);

export const IconDoc = (p) => (
  <Svg {...p}>
    <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" />
    <path d="M14 3v5h5" />
    <path d="M9 13h6M9 17h4" />
  </Svg>
);

export const IconLink = (p) => (
  <Svg {...p}>
    <path d="M9.5 14.5 14.5 9.5" />
    <path d="M11 6.5 12.2 5.3a4 4 0 0 1 5.6 5.6L16.6 12" />
    <path d="M13 17.5 11.8 18.7a4 4 0 0 1-5.6-5.6L7.4 12" />
  </Svg>
);

export const IconChart = (p) => (
  <Svg {...p}>
    <path d="M3.5 3.5v17h17" />
    <rect x="7" y="11" width="2.6" height="6" rx="0.6" />
    <rect x="12" y="7" width="2.6" height="10" rx="0.6" />
    <rect x="17" y="13" width="2.6" height="4" rx="0.6" />
  </Svg>
);

export const IconBalance = (p) => (
  <Svg {...p}>
    <path d="M12 3v18M6 21h12" />
    <path d="M12 5 5 7.5M12 5l7 2.5" />
    <path d="M5 7.5 2.6 13a3 3 0 0 0 4.8 0z" />
    <path d="M19 7.5 16.6 13a3 3 0 0 0 4.8 0z" />
  </Svg>
);

export const IconBuilding = (p) => (
  <Svg {...p}>
    <rect x="5" y="3" width="14" height="18" rx="1.4" />
    <path d="M9 7h2M13 7h2M9 11h2M13 11h2M9 15h2M13 15h2" />
    <path d="M10 21v-3h4v3" />
  </Svg>
);

export const IconBriefcase = (p) => (
  <Svg {...p}>
    <rect x="3" y="7" width="18" height="13" rx="2" />
    <path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
    <path d="M3 12h18M12 11.5v1.5" />
  </Svg>
);

export const IconLightbulb = (p) => (
  <Svg {...p}>
    <path d="M9 18h6M10 21h4" />
    <path d="M12 3a6 6 0 0 0-3.8 10.6c.7.6 1.1 1.2 1.2 2.4h5.2c.1-1.2.5-1.8 1.2-2.4A6 6 0 0 0 12 3z" />
  </Svg>
);

export const IconPhone = (p) => (
  <Svg {...p}>
    <path d="M5 4h3.5l1.6 4-2.1 1.4a11 11 0 0 0 5.2 5.2L14.6 12.5 18.6 14V18a2 2 0 0 1-2.1 2A15.5 15.5 0 0 1 3 6.5 2 2 0 0 1 5 4z" />
  </Svg>
);

export const IconMail = (p) => (
  <Svg {...p}>
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <path d="m3.5 7 8.5 6 8.5-6" />
  </Svg>
);

export const IconLinkedIn = (p) => (
  <Svg {...p}>
    <rect x="3" y="3" width="18" height="18" rx="3" />
    <path d="M7 10.5V17M7 7.2v.01" />
    <path d="M11 17v-3.6a2.2 2.2 0 0 1 4.4 0V17M11 17v-6.5" />
  </Svg>
);

export const IconSearch = (p) => (
  <Svg {...p}>
    <circle cx="11" cy="11" r="7" />
    <path d="m20 20-3.2-3.2" />
  </Svg>
);

export const IconDownload = (p) => (
  <Svg {...p}>
    <path d="M12 3v11" />
    <path d="m7.5 10 4.5 4.5 4.5-4.5" />
    <path d="M5 19.5h14" />
  </Svg>
);

export const IconChevronDown = (p) => (
  <Svg {...p}>
    <path d="m6 9 6 6 6-6" />
  </Svg>
);

export const IconCalendar = (p) => (
  <Svg {...p}>
    <rect x="3.5" y="5" width="17" height="15" rx="2" />
    <path d="M3.5 9.5h17M8 3.5v3M16 3.5v3" />
  </Svg>
);

export const IconUser = (p) => (
  <Svg {...p}>
    <circle cx="12" cy="8" r="3.4" />
    <path d="M5.5 19.5a6.5 6.5 0 0 1 13 0" />
  </Svg>
);

export const IconClose = (p) => (
  <Svg {...p}>
    <path d="M6 6l12 12M18 6 6 18" />
  </Svg>
);

export const IconSliders = (p) => (
  <Svg {...p}>
    <path d="M4 7h10M18 7h2M4 17h2M10 17h10" />
    <circle cx="16" cy="7" r="2.2" />
    <circle cx="8" cy="17" r="2.2" />
  </Svg>
);

export const IconLayers = (p) => (
  <Svg {...p}>
    <path d="m12 3 9 5-9 5-9-5 9-5z" />
    <path d="m3 13 9 5 9-5" />
  </Svg>
);

export const IconClock = (p) => (
  <Svg {...p}>
    <circle cx="12" cy="12" r="8.5" />
    <path d="M12 7.5V12l3 2" />
  </Svg>
);

export const IconMenu = (p) => (
  <Svg {...p}>
    <path d="M4 7h16M4 12h16M4 17h16" />
  </Svg>
);

/* ---------- Newly added icons (used by GlobalResearch.jsx) ---------- */

export const TempleIcon = (p) => (
  <Svg {...p}>
    <path d="M12 2.5 3 8h18z" />
    <path d="M4.5 8v11M8 8v11M12 8v11M16 8v11M19.5 8v11" />
    <path d="M2.5 19.5h19" />
    <path d="M2.5 21.5h19" />
  </Svg>
);

export const TargetIcon = (p) => (
  <Svg {...p}>
    <circle cx="12" cy="12" r="9" />
    <circle cx="12" cy="12" r="5" />
    <circle cx="12" cy="12" r="1.2" fill="currentColor" stroke="none" />
  </Svg>
);

export const MapPinIcon = (p) => (
  <Svg {...p}>
    <path d="M12 21.5s7-6.2 7-11.5a7 7 0 1 0-14 0c0 5.3 7 11.5 7 11.5z" />
    <circle cx="12" cy="10" r="2.4" />
  </Svg>
);

export const PhoneIcon = IconPhone;

export const MailIcon = IconMail;

export const MapIcon = (p) => (
  <Svg {...p}>
    <path d="M9 4 3.5 6v14L9 18l6 2 5.5-2V4L15 6 9 4z" />
    <path d="M9 4v14M15 6v14" />
  </Svg>
);

/* Small uppercase section label with a leading hairline. Variant controls the
   accent colour so it reads correctly on light, orange-tinted and dark beds. */
export function SectionEyebrow({ children, variant = "red", className = "" }) {
  const tone =
    variant === "dark"
      ? "text-brand-orange"
      : variant === "orange"
      ? "text-brand-orange-dark"
      : "text-brand-red";
  return (
    <span
      className={`inline-flex items-center gap-2.5 text-[11px] font-extrabold uppercase tracking-[0.24em] ${tone} ${className}`}
    >
      <span className="h-px w-7 bg-current opacity-60" />
      {children}
    </span>
  );
}

export const ArrowRight = (p) => (
  <Svg {...p}>
    <path d="M5 12h13" />
    <path d="m12.5 6 6 6-6 6" />
  </Svg>
);

export const ArrowLeft = (p) => (
  <Svg {...p}>
    <path d="M19 12H6" />
    <path d="m11.5 18-6-6 6-6" />
  </Svg>
);

export const ArrowUpRight = (p) => (
  <Svg {...p}>
    <path d="M7 17 17 7" />
    <path d="M8 7h9v9" />
  </Svg>
);

export const CheckIcon = (p) => (
  <Svg {...p}>
    <path d="m5 13 4.5 4.5L19 8" />
  </Svg>
);